export const SET_EDIT_SCHEDULE_USERS_LOADED = "SET_EDIT_SCHEDULE_USERS_LOADED";

export const setEditScheduleUsersLoaded = (editScheduleUsersLoaded: boolean) => {
  return {
    editScheduleUsersLoaded,
    type: SET_EDIT_SCHEDULE_USERS_LOADED
  };
};
